<template>
    <master-default>
        <h1 @click="refresh()">Lista</h1>
        
        <table border="1" style="margin:auto" cellspacing="10" cellpadding="10">
          <tr v-for="(row,index) of res.rows" :key="index">
            <td v-for="(col, indc) of row" :key="indc">
              {{col}}
            </td>
          </tr>
        </table>
        
    </master-default>
</template>

<script>
/* eslint-disable */

try{
  var _base = require("@/page/_base.vue").default;
}catch(err){
  var _base = require("@/framework/page/_base.vue").default;
}

export default {
  extends: _base,
  props:["tabela"],
  data () {
    return {
      
    }
  },
  methods:{
    onInit(){
      this.params = {tabela:this.$route.params.p1||this.tabela||'pessoa'};
    }
  },
  components: {
    masterDefault: global.reqClass.requirecmpmix('@/masters/default'),
  },

}
</script>

<style scoped>

</style>
